"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComorbidities = createComorbidities;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    comorbidities: {
        id: "dashboard.comorbidities",
        defaultMessage: "Társbetegségek"
    },
    seenBy: {
        id: "dashboard.seen_by",
        defaultMessage: "Szakvizsgálat történt"
    },
    nephrologistOpinion: {
        id: "dashboard.nephrologist_opinion",
        defaultMessage: "Nefrológia"
    },
    infectologistOpinion: {
        id: "dashboard.infectologist_opinion",
        defaultMessage: "Infektológia"
    },
    diabetologistOpinion: {
        id: "dashboard.diabetologist_opinion",
        defaultMessage: "Diabetológia"
    },
    neurologistOpinion: {
        id: "dashboard.neurologist_opinion",
        defaultMessage: "Neurológia"
    },
    oncologistOpinion: {
        id: "dashboard.oncologist_opinion",
        defaultMessage: "Onkológia"
    },
    vascularSurgeonOpinion: {
        id: "dashboard.vascular_surgeon_opinion",
        defaultMessage: "Érsebészet"
    },
    gastroenterologistOpinion: {
        id: "dashboard.gastroenterologist_opinion",
        defaultMessage: "Gastroenterológia"
    },
    anesthesiologistOpinion: {
        id: "dashboard.anesthesiologist_opinion",
        defaultMessage: "Aneszteziológia"
    },
    endocrinologistOpinion: {
        id: "dashboard.endocrinologist_opinion",
        defaultMessage: "Endokrinológia"
    },
    geneticistOpinion: {
        id: "dashboard.geneticist_opinion",
        defaultMessage: "Genetika"
    },
    hematologistOpinion: {
        id: "dashboard.hematologist_opinion",
        defaultMessage: "Haematológia"
    },
    immunologistOpinion: {
        id: "dashboard.immunologist_opinion",
        defaultMessage: "Immunológia"
    },
    radiologistOpinion: {
        id: "dashboard.radiologist_opinion",
        defaultMessage: "Radiológia"
    },
    rheumatologistOpinion: {
        id: "dashboard.rheumatologist_opinion",
        defaultMessage: "Reumatológia"
    },
    hepatologistOpinion: {
        id: "dashboard.hepatologist_opinion",
        defaultMessage: "Hepatológia"
    }
};
var YesNo;
(function (YesNo) {
    YesNo["YES"] = "YES";
    YesNo["NO"] = "NO";
})(YesNo || (YesNo = {}));
const groups = [
    {
        label: messages.seenBy,
        variant: "dark",
        predicate: (event) => event !== undefined && event.value === YesNo.YES
    }
];
const values = [
    {
        label: messages.nephrologistOpinion,
        query: queries_1.queries.nephrologistOpinion
    },
    {
        label: messages.infectologistOpinion,
        query: queries_1.queries.infectologistOpinion
    },
    {
        label: messages.diabetologistOpinion,
        query: queries_1.queries.diabetologistOpinion
    },
    {
        label: messages.neurologistOpinion,
        query: queries_1.queries.neurologistOpinion
    },
    {
        label: messages.oncologistOpinion,
        query: queries_1.queries.oncologistOpinion
    },
    {
        label: messages.vascularSurgeonOpinion,
        query: queries_1.queries.vascularSurgeonOpinion
    },
    {
        label: messages.gastroenterologistOpinion,
        query: queries_1.queries.gastroenterologistOpinion
    },
    {
        label: messages.anesthesiologistOpinion,
        query: queries_1.queries.anesthetistOpinion
    },
    {
        label: messages.endocrinologistOpinion,
        query: queries_1.queries.endocrinologistOpinion
    },
    {
        label: messages.geneticistOpinion,
        query: queries_1.queries.geneticistOpinion
    },
    {
        label: messages.hematologistOpinion,
        query: queries_1.queries.hematologistOpinion
    },
    {
        label: messages.immunologistOpinion,
        query: queries_1.queries.immunologistOpinion
    },
    {
        label: messages.radiologistOpinion,
        query: queries_1.queries.radiologistOpinion
    },
    {
        label: messages.rheumatologistOpinion,
        query: queries_1.queries.rheumatologistOpinion
    },
    {
        label: messages.hepatologistOpinion,
        query: queries_1.queries.hepatologistOpinion
    }
];
function createComorbidities(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, { label: messages.comorbidities, content });
}
